(function () {
  'use strict';

  var ICONS = {
    portafilter: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6 3v6a6 6 0 0 0 12 0V3"/><path d="M4 3h4M16 3h4"/><path d="M9 9H4M15 9h5"/><path d="M12 15v6"/></svg>',
    machine: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="4" width="14" height="10" rx="1.5"/><path d="M9 8h6M12 14v3"/><path d="M8 20h8l-1-3H9l-1 3Z"/></svg>',
    moka: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M8 21h8l-1-7H9l-1 7Z"/><path d="M9 14 8 8h8l-1 6"/><path d="M8 8V4h8v4"/><path d="M19 10c1.2 0 2-.8 2-2s-.8-2-2-2"/></svg>',
    capsule: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9 3h6l1 4-1 13a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1L8 7l1-4Z"/><path d="M8 9h8"/></svg>',
    pad: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="3"/></svg>',
    dripper: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 6h16"/><path d="M6 6l5 10h2l5-10"/><path d="M12 16v4"/></svg>',
    citrus: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="8"/><path d="M12 4v16M4 12h16M6.3 6.3l11.4 11.4M17.7 6.3 6.3 17.7"/></svg>',
    cacao: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><ellipse cx="12" cy="12" rx="6" ry="9"/><path d="M12 3v18M7 8c2 1 8 1 10 0M7 16c2-1 8-1 10 0"/></svg>',
    nut: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3c4 2 6 6 6 10a6 6 0 0 1-12 0c0-4 2-8 6-10Z"/><path d="M12 9v8"/></svg>',
    flower: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="2"/><path d="M12 9.4c-1-1.7-1-3.7 0-5.4 1 1.7 1 3.7 0 5.4ZM12 14.6c1 1.7 1 3.7 0 5.4-1-1.7-1-3.7 0-5.4ZM9.4 12c-1.7-1-3.7-1-5.4 0 1.7 1 3.7 1 5.4 0ZM14.6 12c1.7-1 3.7-1 5.4 0-1.7 1-3.7 1-5.4 0Z"/></svg>',
    grain: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21V3"/><path d="M12 6l-3 2M12 6l3 2M12 10l-3 2M12 10l3 2M12 14l-3 2M12 14l3 2"/></svg>',
    acid: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3s6 6.5 6 11a6 6 0 0 1-12 0c0-4.5 6-11 6-11Z"/></svg>',
    nocaf: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9h11a3 3 0 0 1 0 6h-1"/><path d="M4 9v7a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-2"/><path d="M3 3l18 18"/></svg>',
    organic: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 20c9 0 14-5 14-14-9 0-14 5-14 14Z"/><path d="M5 20c2-5 5-8 10-11"/></svg>'
  };

  function hex(filled) {
    var path = 'M6 .8 11 3.7v5.8L6 12.4 1 9.5V3.7Z';
    return '<svg viewBox="0 0 12 13"><path class="' + (filled ? 'is-filled' : 'is-empty') + '" d="' + path + '"/></svg>';
  }
  function hexRow(level) {
    var out = '';
    for (var i = 1; i <= 5; i++) out += hex(i <= level);
    return out;
  }
  function starsRow(rating, count) {
    var pct = Math.round(((rating || 0) / 5) * 100);
    return '<span class="kf-stars"><span class="kf-stars-wrap">' +
      '<span class="kf-stars-bg">★★★★★</span>' +
      '<span class="kf-stars-fg" style="width:' + pct + '%">★★★★★</span>' +
      '</span><span class="kf-count">(' + (count || 0) + ')</span></span>';
  }
  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney && window.theme_money_format) {
      return Shopify.formatMoney(cents, window.theme_money_format);
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function initKaffeefinder(root) {
    var productsEl = root.querySelector('[data-kf-products]');
    var stringsEl = root.querySelector('[data-kf-strings]');
    var atcTemplateEl = root.querySelector('[data-kf-atc-templates]');
    if (!productsEl || !stringsEl) return;

    var PRODUCTS = JSON.parse(productsEl.textContent || '[]');
    var STR = JSON.parse(stringsEl.textContent || '{}');

    var QUESTIONS = [
      { key: 'device', type: 'single', title: STR.device.title, options: STR.device.options },
      { key: 'strength', type: 'single', title: STR.strength.title, options: STR.strength.options },
      { key: 'flavor', type: 'multi', title: STR.flavor.title, options: STR.flavor.options },
      { key: 'extras', type: 'multi', title: STR.extras.title, options: STR.extras.options }
    ];

    var answers = {};
    var unlocked = 0;

    var finderEl = root.querySelector('[data-kf-finder]');
    var progressEl = root.querySelector('[data-kf-progress]');
    var resultsEl = root.querySelector('[data-kf-results]');
    var recapEl = root.querySelector('[data-kf-recap]');
    var spotlightEl = root.querySelector('[data-kf-spotlight]');
    var altHeadingEl = root.querySelector('[data-kf-alt-heading]');
    var gridEl = root.querySelector('[data-kf-grid]');
    var emptyEl = root.querySelector('[data-kf-empty]');
    var restartEl = root.querySelector('[data-kf-restart]');

    function isReached(i) {
      if (QUESTIONS[i].type === 'multi') return unlocked >= 2;
      return i <= unlocked;
    }
    function isAnswered(q) {
      if (q.type === 'multi') return (answers[q.key] || []).length > 0;
      return !!answers[q.key];
    }

    function render() {
      finderEl.innerHTML = QUESTIONS.map(renderQuestion).join('');
      QUESTIONS.forEach(function (q, i) {
        var el = document.getElementById('kf-q-' + root.dataset.sectionId + '-' + i);
        if (!el) return;
        if (q.type === 'single') {
          el.querySelectorAll('.kf-option').forEach(function (btn) {
            btn.addEventListener('click', function () { selectSingle(i, btn.dataset.id); });
          });
        } else {
          el.querySelectorAll('.kf-chip').forEach(function (btn) {
            btn.addEventListener('click', function () { toggleMulti(i, btn.dataset.id); });
          });
        }
      });
      updateProgress();
    }

    function renderQuestion(q, i) {
      var reached = isReached(i);
      var classes = 'kf-question is-' + (reached ? 'active' : 'pending') + (isAnswered(q) ? ' is-answered' : '');
      var head = '<div class="kf-q-head"><div class="kf-q-num">' + (i + 1) + '</div>' +
        '<div class="kf-q-titles"><h2>' + q.title + '</h2></div></div>';

      var body = '<div class="kf-q-body"><div>';
      if (q.type === 'single') {
        body += '<div class="kf-options">' + q.options.map(function (o) {
          var sel = answers[q.key] === o.id;
          var iconHtml = o.image
            ? '<img src="' + o.image + '" alt="" loading="lazy">'
            : (o.icon ? ICONS[o.icon] : '<div style="display:flex;gap:2px">' + hexRow(o.hexLevel) + '</div>');
          return '<button class="kf-option' + (sel ? ' is-selected' : '') + '" data-id="' + o.id + '" type="button">' +
            '<span class="kf-option__icon">' + iconHtml + '</span>' +
            '<span class="kf-option__text"><strong>' + o.label + '</strong></span>' +
            '<span class="kf-option__badge"></span></button>';
        }).join('') + '</div>';
      } else {
        var selected = answers[q.key] || [];
        body += '<div class="kf-chips">' + q.options.map(function (o) {
          var sel = selected.indexOf(o.id) > -1;
          var chipIconHtml = o.image ? '<img src="' + o.image + '" alt="" loading="lazy">' : ICONS[o.icon];
          return '<button class="kf-chip' + (sel ? ' is-selected' : '') + '" data-id="' + o.id + '" type="button">' +
            '<span class="kf-chip__icon">' + chipIconHtml + '</span><span>' + o.label + '</span></button>';
        }).join('') + '</div>';
      }
      body += '</div></div>';

      return '<div class="' + classes + '" id="kf-q-' + root.dataset.sectionId + '-' + i + '">' + head + body + '</div>';
    }

    function selectSingle(i, id) {
      answers[QUESTIONS[i].key] = id;
      var wasFrontier = i === unlocked;
      if (wasFrontier) unlocked = Math.min(unlocked + 1, 2);
      render();
      if (wasFrontier) {
        requestAnimationFrame(function () {
          var next = document.getElementById('kf-q-' + root.dataset.sectionId + '-' + (i + 1));
          if (next) next.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
      if (unlocked >= 2) showResults();
    }

    function toggleMulti(i, id) {
      var key = QUESTIONS[i].key;
      var list = answers[key] || [];
      var idx = list.indexOf(id);
      if (idx > -1) list.splice(idx, 1); else list.push(id);
      answers[key] = list;
      render();
      if (unlocked >= 2) showResults();
    }

    function updateProgress() {
      progressEl.querySelectorAll('i').forEach(function (el, idx) {
        var reached = idx < unlocked || (idx === unlocked && QUESTIONS[idx].type === 'multi');
        el.classList.toggle('is-done', reached);
      });
    }

    function scoreProduct(p, ctx) {
      if (ctx.deviceOpt && ctx.deviceOpt.forms.indexOf(p.form) === -1) return null;
      if (ctx.wantsDecaf && p.caffeine !== 'Ohne Koffein') return null;

      var aromas = p.aromas || [];
      if (ctx.flavorValues.length) {
        var hasAnyFlavor = ctx.flavorValues.some(function (v) { return aromas.indexOf(v) > -1; });
        if (!hasAnyFlavor) return null;
      }
      if (ctx.wantsLowAcid && p.low_acid !== 'Ja') return null;
      if (ctx.wantsBio && (p.certifications || []).indexOf('Bio') === -1) return null;

      var score = 0;
      if (ctx.strengthOpt && p.strength === ctx.strengthOpt.value) score += 2;
      ctx.flavorValues.forEach(function (v) { if (aromas.indexOf(v) > -1) score += 2; });
      if (ctx.wantsLowAcid) score += 1;
      if (ctx.wantsBio) score += 1;
      return score;
    }

    function buildContext() {
      var deviceOpt = QUESTIONS[0].options.filter(function (o) { return o.id === answers.device; })[0];
      var strengthOpt = QUESTIONS[1].options.filter(function (o) { return o.id === answers.strength; })[0];
      var flavorIds = answers.flavor || [];
      var flavorOpts = QUESTIONS[2].options.filter(function (o) { return flavorIds.indexOf(o.id) > -1; });
      var extraIds = answers.extras || [];
      var extraOpts = QUESTIONS[3].options.filter(function (o) { return extraIds.indexOf(o.id) > -1; });
      return {
        deviceOpt: deviceOpt,
        strengthOpt: strengthOpt,
        flavorOpts: flavorOpts,
        flavorValues: flavorOpts.map(function (o) { return o.value; }),
        wantsDecaf: extraIds.indexOf('koffeinfrei') > -1,
        wantsLowAcid: extraIds.indexOf('saeurearm') > -1,
        wantsBio: extraIds.indexOf('bio') > -1,
        extraOpts: extraOpts
      };
    }

    function pickResults(ctx) {
      var scored = [];
      PRODUCTS.forEach(function (p) {
        var s = scoreProduct(p, ctx);
        if (s === null) return;
        scored.push({ product: p, score: s });
      });
      var premium = scored.filter(function (r) { return r.product.tier === 'Premium Empfehlung'; }).sort(function (a, b) { return b.score - a.score; });
      var normal = scored.filter(function (r) { return r.product.tier === 'Normale Empfehlung'; }).sort(function (a, b) { return b.score - a.score; });

      var picks = [];
      var used = {};
      function take(list, n) {
        for (var i = 0; i < list.length && n > 0; i++) {
          if (used[list[i].product.id]) continue;
          picks.push(list[i]);
          used[list[i].product.id] = true;
          n--;
        }
      }
      take(premium, 1);
      take(normal, 2);
      if (picks.length < 3) take(premium, 3 - picks.length);
      if (picks.length < 3) take(normal, 3 - picks.length);
      return picks;
    }

    function cardMedia(p) {
      if (p.image) return '<img src="' + p.image + '" alt="" loading="lazy" width="600" height="800">';
      return '<svg viewBox="0 0 300 400"><rect width="300" height="400" fill="var(--kf-cream)"/></svg>';
    }

    function attachAtc(slotEl, atcKey) {
      if (!atcTemplateEl) return;
      var source = atcTemplateEl.content.querySelector('[data-kf-atc-source="' + atcKey + '"]');
      if (!source) return;
      var clone = source.cloneNode(true);
      slotEl.innerHTML = '';
      slotEl.appendChild(clone);
    }

    function cardHtml(entry, ctx, isPremium) {
      var p = entry.product;
      var hexLevel = { Mild: 2, Ausbalanciert: 3, Intensiv: 5 }[p.strength] || 3;
      var productAromas = p.aromas || [];
      var matchedFlavorOpts = ctx.flavorOpts.filter(function (o) { return productAromas.indexOf(o.value) > -1; });
      var tag = matchedFlavorOpts.length ? matchedFlavorOpts.map(function (o) { return o.label; }).join(', ') : productAromas.join(', ');
      var extraText = ctx.extraOpts.map(function (o) { return o.label; }).join(', ');
      var onSale = p.compare_at_price > p.price;
      var priceOld = onSale ? '<span class="kf-price-old">' + formatMoney(p.compare_at_price) + '</span>' : '';
      var pill = isPremium
        ? '<span class="kf-pill is-gold"><svg viewBox="0 0 24 24"><path d="M12 2l2.7 6.6L22 9l-5.3 4.8L18.2 21 12 17.1 5.8 21l1.5-7.2L2 9l7.3-.4L12 2Z"/></svg>' + STR.results.premiumBadge + '</span>'
        : '<span class="kf-pill is-quiet">' + STR.results.normalBadge + '</span>';
      var kicker = isPremium ? '<p class="kf-kicker">' + STR.results.premiumKicker + '</p>' : '';

      return '<div class="' + (isPremium ? 'kf-spotlight' : 'kf-card') + '" data-kf-product-id="' + p.id + '">' +
        '<a class="kf-media" href="' + p.url + '">' + cardMedia(p) + pill + '</a>' +
        '<div class="kf-card-body">' + kicker +
        '<h3><a href="' + p.url + '">' + p.title + '</a></h3>' +
        '<p class="kf-meta">' + (p.form || '') + (tag ? ' · ' + tag : '') + (extraText ? ' · ' + extraText : '') + '</p>' +
        starsRow(p.rating, p.rating_count) +
        '<div class="kf-price-row"><span class="kf-price">' + formatMoney(p.price) + '</span>' + priceOld + '</div>' +
        '<p class="kf-unit">' + STR.results.shippingNote + '</p>' +
        '<div class="kf-fit"><span class="kf-hexes">' + hexRow(hexLevel) + '</span>' + (p.strength || '') + '</div>' +
        '<div class="kf-cta-slot" data-kf-cta-slot></div>' +
        '</div></div>';
    }

    function showResults() {
      var ctx = buildContext();
      var picks = pickResults(ctx);

      var recapItems = [];
      if (ctx.deviceOpt) recapItems.push(ctx.deviceOpt.label);
      if (ctx.strengthOpt) recapItems.push(ctx.strengthOpt.label);
      ctx.flavorOpts.forEach(function (o) { recapItems.push(o.label); });
      ctx.extraOpts.forEach(function (o) { recapItems.push(o.label); });
      recapEl.innerHTML = recapItems.map(function (l) { return '<span class="kf-recap-pill">' + l + '</span>'; }).join('');

      if (!picks.length) {
        spotlightEl.innerHTML = '';
        gridEl.innerHTML = '';
        altHeadingEl.hidden = true;
        emptyEl.hidden = false;
      } else {
        emptyEl.hidden = true;
        var premiumEntry = picks[0];
        var restEntries = picks.slice(1);
        spotlightEl.innerHTML = cardHtml(premiumEntry, ctx, true);
        gridEl.innerHTML = restEntries.map(function (entry) { return cardHtml(entry, ctx, false); }).join('');
        if (restEntries.length) {
          altHeadingEl.textContent = STR.results.alternativesHeading;
          altHeadingEl.hidden = false;
        } else {
          altHeadingEl.hidden = true;
        }
        picks.forEach(function (entry) {
          var cardEl = root.querySelector('[data-kf-product-id="' + entry.product.id + '"]');
          var slot = cardEl && cardEl.querySelector('[data-kf-cta-slot]');
          if (slot) attachAtc(slot, entry.product.atc_key);
        });
      }

      resultsEl.classList.add('is-visible');
    }

    var pendingAtcBtn = null;
    var pendingAtcTimer = null;

    function showAddedFeedback(btn) {
      var original = btn.innerHTML;
      btn.classList.add('is-added');
      btn.innerHTML = '<span class="kf-cta-icon"><svg viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7"/></svg></span>' + STR.results.added;
      setTimeout(function () {
        btn.classList.remove('is-added');
        btn.innerHTML = original;
      }, 1600);
    }

    resultsEl.addEventListener('click', function (e) {
      var btn = e.target.closest('.kf-cta');
      if (!btn || btn.disabled) return;
      pendingAtcBtn = btn;
      clearTimeout(pendingAtcTimer);
      pendingAtcTimer = setTimeout(function () { pendingAtcBtn = null; }, 4000);
    });

    document.addEventListener('product-ajax:added', function () {
      if (!pendingAtcBtn) return;
      clearTimeout(pendingAtcTimer);
      showAddedFeedback(pendingAtcBtn);
      pendingAtcBtn = null;
    });

    if (restartEl) {
      restartEl.addEventListener('click', function () {
        answers = {};
        unlocked = 0;
        resultsEl.classList.remove('is-visible');
        render();
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    render();
  }

  function init() {
    document.querySelectorAll('[data-kaffeefinder]').forEach(function (root) {
      if (root.dataset.kfInitialized) return;
      root.dataset.kfInitialized = '1';
      initKaffeefinder(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();